import { SurveyStepBase } from '@app/member-response-portal/shared/survey-step-base';
//#region Imports
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { Helper } from '@rawlings/core';
import { MemberResponseHelper } from '@app/member-response-portal/shared/member-response-helper';
import { NOT_APPLICABLE, SURVEYSTEPS_INDEX } from '@app/member-response-portal/model/constants';
import { NotificationRequestService } from '@app/member-response-portal/service/notification-request.service';
import { NotifierService } from '@app/core/services/notifier-service';
import { Observable, catchError, map, of } from 'rxjs';
import { OtherBenefitsDto } from '@app/member-response-portal/model/otherBenefitsDto';
import { OtherBenefitsService } from '@app/member-response-portal/service/other-benefits.service';
import { SharedMemberResponseService } from '@app/member-response-portal/service/shared-member-response.service';

//#endregion Imports
@Component({
  selector: 'app-survey-other-benefits',
  templateUrl: './survey-other-benefits.component.html',
  styleUrls: ['./survey-other-benefits.component.scss'],
})
export class SurveyOtherBenefitsComponent extends SurveyStepBase implements OnInit
{
  //#region Public Variables
  public CurrentlyReceivingOtherBenefitsForm: FormGroup = new FormGroup({});
  public SpouseCurrentlyReceivingOtherBenefitsForm: FormGroup = new FormGroup(
    {}
  );
  public CurrentlyReceivingOtherBenefits: boolean = null;
  public ShowReceivingOtherBenefitsQuestion: boolean = false;
  public ShowSpouseReceivingOtherBenefitsQuestion: boolean = false;
  public ShowSpouseCurrentlyReceivingOtherBenefits: boolean = false;
  public ShowSpouseQuestion: boolean = false;
  public SpouseCurrentlyReceivingOtherBenefits: boolean = false;
  //#endregion Public Variables

  //#region Private Variables
  //#endregion Private Variables

  //#region Properties

  public get ReceivingOtherBenefits(): FormControl {
    return this.Form.get('ReceivingOtherBenefits') as FormControl;
  }

  public get SpouseReceivingOtherBenefits(): FormControl {
    return this.Form.get('SpouseReceivingOtherBenefits') as FormControl;
  }

  public get HasSpouseReceivingOtherBenefits(): FormControl {
    return this.Form.get('HasSpouseReceivingOtherBenefits') as FormControl;
  }

  public get RetireePlan(): FormControl {
    return this.Form.get('RetireePlan') as FormControl;
  }

  public get LongTermDisability(): FormControl {
    return this.Form.get('LongTermDisability') as FormControl;
  }

  public get COBRAContinuationOfCoverage(): FormControl {
    return this.Form.get('COBRAContinuationOfCoverage') as FormControl;
  }

  public get WorkersCompensation(): FormControl {
    return this.Form.get('WorkersCompensation') as FormControl;
  }

  public get ShortTermDisability(): FormControl {
    return this.Form.get('ShortTermDisability') as FormControl;
  }

  public get SpouseRetireePlan(): FormControl {
    return this.Form.get('SpouseRetireePlan') as FormControl;
  }

  public get SpouseLongTermDisability(): FormControl {
    return this.Form.get('SpouseLongTermDisability') as FormControl;
  }

  public get SpouseCOBRAContinuationOfCoverage(): FormControl {
    return this.Form.get('SpouseCOBRAContinuationOfCoverage') as FormControl;
  }

  public get SpouseWorkersCompensation(): FormControl {
    return this.Form.get('SpouseWorkersCompensation') as FormControl;
  }

  public get SpouseShortTermDisability(): FormControl {
    return this.Form.get('SpouseShortTermDisability') as FormControl;
  }

  private get OtherBenefitsDto(): OtherBenefitsDto {
    const hasSpouseReceivingOtherBenefits: boolean =
      this.HasSpouseReceivingOtherBenefits?.value ?? null;

    const otherBenefitsDto: OtherBenefitsDto = {
      QueueLetterId: this.sharedMemberResponseService.GetQueueLetterId(),
      SurveyResponseId: this.SurveyResponseId,
      ReceivingOtherBenefits: this.CurrentlyReceivingOtherBenefits,
      RetireePlan: this.CurrentlyReceivingOtherBenefits
        ? this.RetireePlan.value
        : null,
      COBRAContinuationOfCoverage: this.CurrentlyReceivingOtherBenefits
        ? this.COBRAContinuationOfCoverage.value
        : null,
      ShortTermDisability: this.CurrentlyReceivingOtherBenefits
        ? this.ShortTermDisability.value
        : null,
      LongTermDisability: this.CurrentlyReceivingOtherBenefits
        ? this.LongTermDisability.value
        : null,
      WorkersCompensation: this.CurrentlyReceivingOtherBenefits
        ? this.WorkersCompensation.value
        : null,
      HasSpouseReceivingOtherBenefits: hasSpouseReceivingOtherBenefits,
      SpouseReceivingOtherBenefits: hasSpouseReceivingOtherBenefits,
      SpouseRetireePlan: hasSpouseReceivingOtherBenefits
        ? this.SpouseRetireePlan.value
        : null,
      SpouseCOBRAContinuationOfCoverage: hasSpouseReceivingOtherBenefits
        ? this.SpouseCOBRAContinuationOfCoverage.value
        : null,
      SpouseShortTermDisability: hasSpouseReceivingOtherBenefits
        ? this.SpouseShortTermDisability.value
        : null,
      SpouseLongTermDisability: hasSpouseReceivingOtherBenefits
        ? this.SpouseLongTermDisability.value
        : null,
      SpouseWorkersCompensation: hasSpouseReceivingOtherBenefits
        ? this.SpouseWorkersCompensation.value
        : null,
      IsCompleted: this.Form.valid,
    };
    return otherBenefitsDto;
  }
  //#endregion Properties

  //#region Constructor
  constructor(
    protected notifierService: NotifierService,
    protected sharedMemberResponseService: SharedMemberResponseService,
    protected changeDetectorRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private notificationRequestService: NotificationRequestService,
    private otherBenefitsService: OtherBenefitsService
  ) {
    super(
        `Other Benefits`,
        SURVEYSTEPS_INDEX.OTHER_BENEFITS,
        false,
        'OtherBenefits',
        changeDetectorRef,
        notifierService,
        sharedMemberResponseService
      );
  }

  public ngOnInit(): void {
    this.InitStep();
  }

  //#endregion Constructor

  //#region Public Methods
  public CreateOtherBenefitsFormGroup(): FormGroup {
    return this.fb.group({
      SurveyResponseId: [this.SurveyResponseId, Validators.required],
      ReceivingOtherBenefits: ['', Validators.required],
      HasSpouseReceivingOtherBenefits: [null],
      SpouseReceivingOtherBenefits: [null, Validators.required],
      RetireePlan: [null],
      COBRAContinuationOfCoverage: [null],
      ShortTermDisability: [null],
      LongTermDisability: [null],
      WorkersCompensation: [null],
      SpouseRetireePlan: [null],
      SpouseCOBRAContinuationOfCoverage: [null],
      SpouseShortTermDisability: [null],
      SpouseLongTermDisability: [null],
      SpouseWorkersCompensation: [null],
    });
  }

  public OnCheckboxChange(): any {
    this.handleConditionalMandatoryFields();
  }

  public HandleReceivingOtherBenefitsToggleEvent(event: {
    IsChecked: boolean;
    IsConfirmed: boolean;
  }): void {
    this.CurrentlyReceivingOtherBenefits = event.IsChecked;
    this.ShowReceivingOtherBenefitsQuestion = event.IsChecked;
    this.ShowSpouseQuestion = true;
    this.setValidatorsForReceivingOtherBenefits(event.IsChecked);
  }


  public HandleSpouseToggleEvent(event: {
    IsChecked: boolean;
    IsConfirmed: boolean;
  }): void {
    if (!event.IsConfirmed) {
      this.Form.patchValue({
        SpouseReceivingOtherBenefits:
          MemberResponseHelper.GetStringForYesNoValue(
            this.HasSpouseReceivingOtherBenefits.value
          ) ?? NOT_APPLICABLE,
      });
      return;
    }

    if (event.IsChecked === null) {
      this.resetSpouseBenefits(null);
      this.HasSpouseReceivingOtherBenefits.removeValidators(
        Validators.required
      );
      this.HasSpouseReceivingOtherBenefits.updateValueAndValidity();
      return;
    }

    if (event.IsChecked) {
      this.Form.get('HasSpouseReceivingOtherBenefits')?.setValue(true);
      this.resetSpouseBenefits(true);
      this.ShowSpouseCurrentlyReceivingOtherBenefits = true;
      this.setValidatorsForSpouseReceivingOtherBenefits(true);
    } else {
      this.Form.get('HasSpouseReceivingOtherBenefits')?.setValue(false);
      this.resetSpouseBenefits(false);
    }
  }

  public SkipSpouseCurrentlyReceivingOtherBenefits(): boolean {
    return Helper.IsEmpty(this.HasSpouseReceivingOtherBenefits.value);
  }
  //#endregion Public Methods

  //#region Protected Methods
  protected HandleRequest(): Observable<boolean> {
    return this.otherBenefitsService.Save(this.OtherBenefitsDto).pipe(
      map(
        (
          result: GenericMemberResponsePortalResponseDto<OtherBenefitsDto>
        ): boolean => {
          if (!result.Success) {
            result.IsSurveySubmitted ? this.notificationRequestService.ShowFailedRequestAndLogout(result) : this.notificationRequestService.ShowFailedRequestAndLogout(null);
            return false;
          }
          return true;
        }
      ),
      catchError(() => {
        return of(false);
      })
    );
  }
  protected BuildForm(): void {
    this.Form = this.CreateOtherBenefitsFormGroup();
  }

  protected GetFormData() : any {
    return this.OtherBenefitsDto;
  }

  protected LoadData(): void {
    const ininitialData: any = this.sharedMemberResponseService.GetSurveySummarySection(this.FormKey);

    if(ininitialData){
       this.setFormValues(ininitialData);
       this.handleConditionalMandatoryFields();
       this.Form.updateValueAndValidity();
   }
  }
  //#endregion Protected Methods
  //#region Private Methods
  private resetSpouseBenefits(formValue: boolean | null): void {
    this.Form.get('HasSpouseReceivingOtherBenefits')?.setValue(formValue);
    this.ShowSpouseCurrentlyReceivingOtherBenefits = false;
    this.resetSpouseReceivingOtherBenefitsFormValues();
    this.setValidatorsForSpouseReceivingOtherBenefits(false);
  }

  private handleConditionalMandatoryFields(): void {
    if (this.ReceivingOtherBenefits.value) {
      const benefitFields: FormControl[] = [
        this.RetireePlan,
        this.COBRAContinuationOfCoverage,
        this.ShortTermDisability,
        this.LongTermDisability,
        this.WorkersCompensation,
      ];

      const spouseBenefitFields: FormControl[] = [
        this.SpouseRetireePlan,
        this.SpouseCOBRAContinuationOfCoverage,
        this.SpouseShortTermDisability,
        this.SpouseLongTermDisability,
        this.SpouseWorkersCompensation,
      ];

      if (
        MemberResponseHelper.GetBoolFromYesNoValue(
          this.ReceivingOtherBenefits.value
        )
      ) {
        const isAnyBenefitSelected: boolean = benefitFields.some(
          (control: any) => control.value === true
        );
        if (!isAnyBenefitSelected) {
          benefitFields.forEach((control: any) => {
            control.addValidators(Validators.required);
            control.setValue(null);
          });
        } else {
          benefitFields.forEach((control: any) => {
            control.removeValidators(Validators.required);
            if (control.value === null) {
              control.setValue(false);
            }
          });
        }
      } else {
        benefitFields.forEach((control: any) =>
          control.removeValidators(Validators.required)
        );
        this.SpouseReceivingOtherBenefits.removeValidators(Validators.required);
        this.SpouseReceivingOtherBenefits.updateValueAndValidity();
        this.HasSpouseReceivingOtherBenefits.removeValidators(
          Validators.required
        );
        this.HasSpouseReceivingOtherBenefits.updateValueAndValidity();
      }

      if (
        MemberResponseHelper.GetBoolFromYesNoValue(
          this.SpouseReceivingOtherBenefits.value
        )
      ) {
        const isAnySpouseBenefitSelected: boolean = spouseBenefitFields.some(
          (control: any) => control.value
        );
        if (!isAnySpouseBenefitSelected) {
          spouseBenefitFields.forEach((control: any) => {
            control.addValidators(Validators.required);
            control.setValue(null);
          });
        } else {
          spouseBenefitFields.forEach((control: any) => {
            control.removeValidators(Validators.required);
            if (control.value === null) {
              control.setValue(false);
            }
          });
        }
      } else {
        spouseBenefitFields.forEach((control: any) =>
          control.removeValidators(Validators.required)
        );
      }

      benefitFields
        .concat(spouseBenefitFields)
        .forEach((control: any) => control.updateValueAndValidity());
    }
  }

  private setValidatorsForReceivingOtherBenefits(isRequired: boolean): void {
    const benefitFields: FormControl[] = [
      this.RetireePlan,
      this.COBRAContinuationOfCoverage,
      this.ShortTermDisability,
      this.LongTermDisability,
      this.WorkersCompensation,
    ];

    benefitFields.forEach((control: any) => {
      if (isRequired) {
        control.addValidators(Validators.required);
      } else {
        control.removeValidators(Validators.required);
        control.setValue(null);
      }
      control.updateValueAndValidity();
    });
  }

  private setValidatorsForSpouseReceivingOtherBenefits(
    isRequired: boolean
  ): void {
    const spouseBenefitFields: FormControl[] = [
      this.SpouseRetireePlan,
      this.SpouseCOBRAContinuationOfCoverage,
      this.SpouseShortTermDisability,
      this.SpouseLongTermDisability,
      this.SpouseWorkersCompensation,
    ];

    spouseBenefitFields.forEach((control: any) => {
      if (isRequired) {
        control.addValidators(Validators.required);
      } else {
        control.removeValidators(Validators.required);
        control.setValue(null);
      }
      control.updateValueAndValidity();
    });
  }

  private resetSpouseReceivingOtherBenefitsFormValues(): void {
    const spouseBenefitFields: FormControl[] = [
      this.SpouseRetireePlan,
      this.SpouseCOBRAContinuationOfCoverage,
      this.SpouseShortTermDisability,
      this.SpouseLongTermDisability,
      this.SpouseWorkersCompensation,
    ];

    spouseBenefitFields.forEach((control: any) => control.reset());
  }

  private setFormValues(otherBenefitsDto: OtherBenefitsDto): void {
    this.Form.patchValue({
      SurveyResponseId: this.SurveyResponseId,
      ReceivingOtherBenefits: MemberResponseHelper.GetStringToggleValue(
        otherBenefitsDto.ReceivingOtherBenefits
      ),
      SpouseReceivingOtherBenefits: MemberResponseHelper.GetStringToggleValue(otherBenefitsDto.SpouseReceivingOtherBenefits) || NOT_APPLICABLE,
      HasSpouseReceivingOtherBenefits:
        otherBenefitsDto.HasSpouseReceivingOtherBenefits,
      RetireePlan: otherBenefitsDto.RetireePlan,
      COBRAContinuationOfCoverage: otherBenefitsDto.COBRAContinuationOfCoverage,
      LongTermDisability: otherBenefitsDto.LongTermDisability,
      ShortTermDisability: otherBenefitsDto.ShortTermDisability,
      WorkersCompensation: otherBenefitsDto.WorkersCompensation,
      SpouseRetireePlan: otherBenefitsDto.SpouseRetireePlan,
      SpouseCOBRAContinuationOfCoverage:
        otherBenefitsDto.SpouseCOBRAContinuationOfCoverage,
      SpouseLongTermDisability: otherBenefitsDto.SpouseLongTermDisability,
      SpouseShortTermDisability: otherBenefitsDto.SpouseShortTermDisability,
      SpouseWorkersCompensation: otherBenefitsDto.SpouseWorkersCompensation,
    });

    this.CurrentlyReceivingOtherBenefits = MemberResponseHelper.GetBooleanToggleValue(otherBenefitsDto.ReceivingOtherBenefits);
    this.ShowReceivingOtherBenefitsQuestion = MemberResponseHelper.GetBooleanToggleValue(otherBenefitsDto.ReceivingOtherBenefits);
    this.ShowSpouseCurrentlyReceivingOtherBenefits = MemberResponseHelper.GetBooleanToggleValue(otherBenefitsDto.SpouseReceivingOtherBenefits) ?? false;
    this.ShowSpouseQuestion = true;
  }
  //#endregion Private Methods
}
